<template>
    <div class="p-admin-conf-law">
        <div
            v-if="$locale.type === 'consul'"
            class="card mb-3">
            <div class="card-header">規約設定</div>
            <div class="card-body" v-if="configurations">
                <div v-for="(conf, index) in configurations">
                    <div v-if="conf.value_type === confValue.datetime" class="m-1">
                        <div class="form-group m-form__group vc-conf-datetime">
                            <label
                                v-if="conf.is_display_name"
                                :for="`key-${conf.key}`"
                                class="vc-conf-name mb-1">
                                {{ conf.name }}：
                            </label>
                            <p class="small text-muted mb-2">{{ conf.desc }}</p>
                            <div class="d-flex align-items-center">
                                <span
                                    v-if="conf.text_prefix !== null"
                                    class="small text-muted mr-2">
                                    {{ conf.text_prefix }}
                                </span>
                                <flat-pickr
                                    v-model="configurations[index].value"
                                    :config="{ enableTime: true, enableSeconds: true, time_24hr: true, locale: flatPickerLocale }"
                                    :id="`key-${conf.key}`"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"/>
                                <span
                                    v-if="conf.text_suffix !== null"
                                    class="small text-muted ml-2">
                                    {{ conf.text_suffix }}
                                </span>
                            </div>
                            <div
                                v-if="errors[ `${index}.${helper.valueField(conf)}` ]"
                                class="invalid-feedback d-block mt-1">
                                {{ errors[ `${index}.${helper.valueField(conf)}` ][0]}}
                            </div>
                        </div>
                    </div>
                    <div v-else-if="conf.value_type === confValue.str" class="m-1">
                        <div class="form-group m-form__group">
                            <label
                                v-if="conf.is_display_name"
                                :for="`key-${conf.key}`"
                                class="vc-conf-name">
                                {{ conf.name }}：
                            </label>
                            <input
                                v-model="configurations[index].value"
                                :id="`key-${conf.key}`"
                                class="form-control m-input"
                                :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                type="text"
                                style="max-width:200px;">
                            <div
                                v-if="errors[ `${index}.${helper.valueField(conf)}` ]"
                                class="invalid-feedback d-block mt-1">
                                {{ errors[ `${index}.${helper.valueField(conf)}` ][0]}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button
                        @click="updateConfigurations"
                        :disabled="inProgress"
                        class="btn btn-yokumiru-orange btn-settings mt-3">
                        保存
                    </button>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-header">特定商取引法に基づく表記の設定</div>
            <div class="card-body" v-if="configurations">
                <div v-for="(conf, index) in configurations">
                    <div v-if="conf.value_type === confValue.text" class="m-1">
                        <div class="form-group m-form__group">
                            <div class="d-flex align-items-center mb-3">
                                <span class="small text-muted mr-3">
                                    公開URL:&nbsp;<a :href="publishedUrl" target="_blank">{{ publishedUrl }}</a>
                                </span>
                                <b-button
                                    style="font-size:0.7rem;"
                                    size="sm"
                                    variant="yokumiru-dark-green"
                                    :disabled="inProgressPreview"
                                    :href="previewUrl"
                                    target="_blank">
                                    プレビュー
                                </b-button>
                                <div
                                    v-show="inProgressPreview"
                                    class="u-loader u-loader--xs vc-loader ml-2">
                                </div>
                            </div>
                            <quill-editor
                                ref="quillEditorLaw"
                                v-model="configurations[index].value"
                                :id="`key-${conf.key}`"
                                :options="editorOption"
                                @blur="storePreview(configurations[index].value, 0)"
                                @change="storePreview(configurations[index].value)">
                            </quill-editor>
                            <div
                                v-if="errors[ `${index}.${helper.valueField(conf)}` ]"
                                class="invalid-feedback d-block mt-1">
                                {{ errors[ `${index}.${helper.valueField(conf)}` ][0]}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button
                        @click="updateConfigurations"
                        :disabled="inProgress"
                        class="btn btn-yokumiru-orange btn-settings mt-3">
                        保存
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import flatPickr from 'vue-flatpickr-component'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'

export default {
    components: {
        quillEditor,
        flatPickr,
    },

    props: {
        conf: {
            type: Array,
            required: true,
        },
        appUrl: {
            type: String,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            flatPickerLocale: Japanese,
            configurations: [],
            preview: null,
            errors: {},
            timer: null,
            inProgress: false,
            inProgressPreview: false,
            confCategory: constants.confCategory,
            confValue: constants.confValue,
            editorOption: {
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline'],
                            [{ 'header': [1, 2, 3, 4, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            ['link', 'divider'],
                        ],
                        // @see https://quilljs.com/docs/modules/toolbar/#handlers
                        handlers: {
                            divider: function() {
                                this.quill.format('divider', '-')
                            },
                        },
                    },
                },
                placeholder: 'ここに内容を入力してください',
            },
        }
    },

    computed: {
        /**
         * 更新データ準備
         *
         * @return {object}
         */
        preparedConfigurations: function () {
            return this.helper.bindConfigurationsValue(this.configurations)
        },

        publishedUrl: function () {
            return `${this.appUrl}/law`
        },

        previewUrl: function () {
            return `${this.appUrl}/admin/cms_previews/law`
        },
    },

    methods: {
        /**
         * プレビュー保存
         */
        storePreview: function (value, delay = 1500) {
            clearTimeout(this.timer)

            this.timer = setTimeout(async () => {
                if (this.inProgressPreview) return
                this.inProgressPreview = true

                const endpoint = constants.admin.cms_previews.endpoint.base
                const data = { key: 'law', html: value }

                await axios.post(endpoint, data)
                    .then(() => {
                        this.preview = value
                    })
                    .catch(() => {
                        console.error('プレビューの保存に失敗しました。')
                    })

                this.inProgressPreview = false
            }, delay)
        },

        /**
         * 設定更新
         */
        updateConfigurations: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.configurations.endpoint.base

            await axios.post(endpoint, this.preparedConfigurations)
                .then(() => {
                    this.errors = {}
                    bus.$emit('alert-success', '設定を更新しました。')
                })
                .catch(({response}) => {
                    this.errors = response.data.errors
                    bus.$emit('alert-danger')
                })

            this.inProgress = false
        },
    },

    watch: {
        conf: function (conf) {
            this.configurations = conf

            const preview = this.configurations.find(configuration => configuration.key === 'law')
            this.preview = preview ? preview.value : null
        },
    }
}
</script>

<style scoped lang="scss">
.vc-loader {
    width: 16px;
    height: 16px;
}
</style>
